import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
// reactstrap components
import { ModalBody, Modal, ModalHeader } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";
import Screens from "./Screens";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

const ScreenSettingModal: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { showScreensModal, setIsModalOpen, personalScreen, orderedScreens } = rootStore.screensStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);


  return (
    <>
      <Modal
        isOpen={showScreensModal}
        toggle={() => setIsModalOpen(!showScreensModal)}
        className={classNames("screenModal")}
        contentClassName= "customModalContent"
      >
        <ModalHeader
        className={classNames("screenModalHeader", theme!.headerColor, theme!.headerTextColor)}
          // className="screenModalHeader"
          toggle={() => setIsModalOpen(!showScreensModal)}
          close={<button className={classNames("closeScreenModalIcon", theme!.headerTextColor)} onClick={() =>setIsModalOpen(!showScreensModal)}><i className="far fa-times-circle fa-lg"></i></button>}
        >
          {t("screens_modal_title")}
        </ModalHeader>
        <ModalBody className="customScreenModal ">
          <Screens personalScreen={personalScreen} connectedScreens={orderedScreens} />
        </ModalBody>
      </Modal>
    </>
  );
};

export default observer(ScreenSettingModal);
